export default __webpack_public_path__ + "static/media/nodejs.bb6a78b7.svg";